import _ from 'lodash'
import VueRouter from 'vue-router'
import Settings from '@/config/Settings'
import DefaultLanguage from '@/core/js/DefaultLanguage'
import Route_map from '@/Route.json'
import configBuild from '@/../config/index.js'

const modeBuild = (process.env.NODE_ENV === 'production') ? 'build' : 'dev'

let map = []

// on format Route_map pour qu'il ressemble a
// http://vuejs.github.io/vue-router/en/named.html
_.forEach(Settings.locale, lang => {
  let prefix = (Settings.prefixRoute) ? '/' + lang : ''
  _.forEach(Route_map, (route, key) => {
    map.push({
      path: prefix + route[lang],
      name: key + '.' + lang,
      meta: {
        name: key,
        lang: lang
      },
      component: require('@/' + route.component + '.vue').default
    })
  })
})

// les routes doivent etre unique
if(map.length !== _.uniqBy(map, 'path').length)
  throw new Error('DUPLICATE ROUTE FOUND, CHECK Route.js')

// redirection sur la home (lang detect) + 404
map.push({ path: '/', redirect: { name: 'museum.' + DefaultLanguage, params: { slug: 'introduction' } }})
map.push({ path: '/eng', redirect: { name: 'museum.en', params: { slug: 'introduction' } }})
map.push({ path: '/fr', redirect: { name: 'museum.fr', params: { slug: 'introduction' } }})
map.push({ path: '*', redirect: { name: 'museum.' + DefaultLanguage, params: { slug: 'introduction' } }})

const router = new VueRouter({
  mode: Settings.localAssets ?  'hash' : 'history',
  base: configBuild[modeBuild].assetsPublicPath,
  routes: map,
})

export default router



// WEBPACK FOOTER //
// ./src/Route.js